import React from 'react';
import SubPageTemplate from '../components/SubPageTemplate';

const SolutionD = () => {
  const features = [
    { title: 'Smart Recruiting', description: 'AI-assisted hiring process' },
    { title: 'Onboarding Automation', description: 'Seamless new hire experience' },
    { title: 'Performance Management', description: 'Continuous feedback and growth' },
    { title: 'Employee Engagement', description: 'Pulse surveys and insights' },
    { title: 'Benefits Administration', description: 'Simplified HR operations' },
    { title: 'Compliance Tracking', description: 'Stay regulation-ready' },
  ];

  return (
    <SubPageTemplate
      title="Human Resources"
      description="HR automation and insights that put people first."
      features={features}
    />
  );
};

export default SolutionD;
